import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { f, database, storage, auth } from "../config";
import firebase from "firebase";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import Swal from "sweetalert2";
import emailjs from "emailjs-com";
import axios from "axios";

function Users() {
  const [showmodal, setshowmodal] = useState(false);
  const [adminusers, setadminusers] = useState([]);
  const [dataAvailable, setdataAvailable] = useState(false);
  const [amount, setamount] = useState("");
  const [amountprofits, setamountprofits] = useState("");
  const [amountBonus, setamountBonus] = useState("");
  const [amountreferralearn, setamountreferralearn] = useState("");
  const [amounttotalprofit, setamounttotalprofit] = useState("");
  const [amountTotaldeposit, setamountTotaldeposit] = useState("");
  const [amountTotalwithdrawal, setamountTotalwithdrawal] = useState("");
  const [loading, setloading] = useState(false);
  const [usertofind, setusertofind] = useState("");

  const [lastdocument, setlastdocument] = useState(null);
  const navigate = useNavigate();
  const [{ userdetails, loggedin, singleuser, singleuserkyc }, dispatch] =
    useContext(GlobalContext);

  useEffect(() => {
    authcheck();
  }, []);

  const authcheck = async () => {
    setloading(true);
    const userdata = await f.auth().onAuthStateChanged(function (user) {
      if (user) {
        var userid = f.auth().currentUser;
        console.log(userid);
        var userids = userid.uid;
        if (userids == "vKSvpr8AdihqQJ1KT3DCItILBqw2") {
          adminfetchall();
        } else {
          navigate("/login");
        }
        // console.log(adminusers);
        //  setloggedin(true);
      } else {
        navigate("/login");
      }
    });
  };

  const setSelecteduser = (data) => {
    dispatch({ type: "setsingleuser", snippet: data });
    setshowmodal(true);
    // navigate("/adminviews");
    // handleOpen()
  };

  const adminfetchall = async () => {
    try {
      const data = await db
        .collection("users")
        .orderBy("timestamp", "desc")
        .limit(10)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let User = doc.data();
            User.id = doc.id;
            adminusers.push(User);
          });
          console.log(snapshot.docs[snapshot.docs.length - 1]);
          setlastdocument(snapshot.docs[snapshot.docs.length - 1]);
        });

      setloading(false);

      console.log(adminusers);
      const set = await setdataAvailable(true);
    } catch (error) {
      console.log(error);
    }
  };

  const getNextDocuments = async () => {
    const ref = db
      .collection("users")
      .orderBy("timestamp", "desc")
      .startAfter(lastdocument || 0)
      .limit(10);
    const data = await ref.get();

    data.docs.forEach((doc) => {
      let User = doc.data();
      User.id = doc.id;
      adminusers.push(User);
    });

    setlastdocument(data.docs[data.docs.length - 1]);
    console.log(adminusers);
    setdataAvailable(true);
  };

  const finduser = (e) => {
    // if (e.which === null) return String.fromCharCode(e.keyCode); // IE
    // if (e.which !== 0 && e.charCode !== 0) return String.fromCharCode(e.which); // Other Browsers
    // return null; // Special Key Clicked
    const firstusers = adminusers;
    const filteredUser = adminusers.filter((user) => {
      return user.email.toLowerCase().includes(e.target.value.toLowerCase());
    });
    setusertofind(filteredUser);
    setadminusers(filteredUser);
    console.log(filteredUser);
    console.log(adminusers);
  };

  const Increamentacc = async (bal) => {
    //increase balance by value
    if (amount !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse = parseFloat(singleuser.balance) + parseFloat(amount);
      const decrement = firebase.firestore.FieldValue.increment(
        -parseInt(amount)
      );
      washingtonRef
        .update({
          balance: balanceToUse,
          // lockedbalance: 0,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  const decrease = async (bal) => {
    //decrease balance by value
    if (amount !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse = parseFloat(singleuser.balance) - parseFloat(amount);
      const decrement = firebase.firestore.FieldValue.increment(
        -parseInt(amount)
      );
      washingtonRef
        .update({
          balance: balanceToUse,
          // lockedbalance: 0,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  const Fakeupdate = () => {
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: "Your changes has been saved",
      showConfirmButton: false,
      timer: 1500,
    });
  };
  const deleteUser = (uid) => {
    console.log(uid);
    Swal.fire({
      title: "Are you sure You want to delete this User?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteUser(uid);
        db.collection("users")
          .doc(uid)
          .delete()
          .then(() => {
            console.log(uid);
            console.log("Document successfully deleted!");
            Swal.fire(
              "Deletion in progress",
              "The User is being deleted await confirmation.",
              "pending"
            );
          })
          .catch((error) => {
            console.error("Error removing document: ", error);
          });
      }
    });
  };

  const DeleteUser = async (uid) => {
    await axios
      .delete(`https://renderallmybackend.onrender.com/api/deleteUser/${uid}`)
      .then((response) => {
        console.log(response.data); // User deleted successfully
        Swal.fire("Deleted!", "The User has been deleted.", "success");
        navigate("/");
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      });
  };

  const [TradingPlan, setTradingPlan] = useState("");
  const [TradingType, setTradingType] = useState("");
  const [TradingAmount, setTradingAmount] = useState("");

  const UpadateUserTrading = async (uid) => {
    if (TradingAmount !== "" && TradingType !== "" && TradingPlan !== "") {
      const d1 = new Date();
      var washingtonRef = db.collection("users").doc(singleuser.id);
      await washingtonRef.update({
        ProfitsHistory: firebase.firestore.FieldValue.arrayUnion({
          amt: TradingAmount,
          date: Date.now(),
          Type: TradingType,
          Name: TradingPlan,
        }),
      });
      Swal.fire(
        "Updated!",
        "The User Transaction has been Updated.",
        "success"
      );
    } else {
      Swal.fire("Error!", "Incomplete information", "error");
    }
  };

  const IncreamentProfits = async (bal) => {
    //increase balance by value
    if (amountprofits !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.totalearnings) + parseFloat(amountprofits);
      washingtonRef
        .update({
          totalearnings: balanceToUse,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  const decreaseProfits = async (bal) => {
    //decrease balance by value
    if (amountprofits !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.totalearnings) - parseFloat(amountprofits);
      washingtonRef
        .update({
          totalearnings: balanceToUse,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  // bonus
  const IncreamentBonus = async (bal) => {
    //increase balance by value
    if (amountBonus !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.lockedbalance) + parseFloat(amountBonus);
      washingtonRef
        .update({
          lockedbalance: balanceToUse,
          //lockedbalance:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  const decreaseBonus = async (bal) => {
    //decrease balance by value
    if (amountBonus !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.lockedbalance) - parseFloat(amountBonus);
      washingtonRef
        .update({
          lockedbalance: balanceToUse,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  // referralearn
  // bonus
  const Increamentreferralearn = async (bal) => {
    //increase balance by value
    if (amountreferralearn !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.referralearn) + parseFloat(amountreferralearn);
      washingtonRef
        .update({
          referralearn: balanceToUse,
          //referralearn:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  const decreasereferralearn = async (bal) => {
    //decrease balance by value
    if (amountreferralearn !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.referralearn) - parseFloat(amountreferralearn);
      washingtonRef
        .update({
          referralearn: balanceToUse,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  // referralearn
  // bonus
  const Increamenttotalprofit = async (bal) => {
    //increase balance by value
    if (amounttotalprofit !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.totalprofit) + parseFloat(amounttotalprofit);
      washingtonRef
        .update({
          totalprofit: balanceToUse,
          //totalprofit:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  const decreasetotalprofit = async (bal) => {
    //decrease balance by value
    if (amounttotalprofit !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.totalprofit) - parseFloat(amounttotalprofit);
      washingtonRef
        .update({
          totalprofit: balanceToUse,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  // ToatalDeposit
  const IncreamentTotaldeposit = async (bal) => {
    //increase balance by value
    if (amountTotaldeposit !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.Totaldeposit) + parseFloat(amountTotaldeposit);
      washingtonRef
        .update({
          Totaldeposit: balanceToUse,
          //Totaldeposit:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  const decreaseTotaldeposit = async (bal) => {
    //decrease balance by value
    if (amountTotaldeposit !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.Totaldeposit) - parseFloat(amountTotaldeposit);
      washingtonRef
        .update({
          Totaldeposit: balanceToUse,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  // ToatalWithdrawal
  const IncreamentTotalwithdrawal = async (bal) => {
    //increase balance by value
    if (amountTotalwithdrawal !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.Totalwithdrawal) +
        parseFloat(amountTotalwithdrawal);
      washingtonRef
        .update({
          Totalwithdrawal: balanceToUse,
          //Totalwithdrawal:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  const decreaseTotalwithdrawal = async (bal) => {
    //decrease balance by value
    if (amountTotalwithdrawal !== "") {
      setloading(true);
      var washingtonRef = db.collection("users").doc(singleuser.id);
      const balanceToUse =
        parseFloat(singleuser.Totalwithdrawal) -
        parseFloat(amountTotalwithdrawal);
      washingtonRef
        .update({
          Totalwithdrawal: balanceToUse,
          //totalearnings:balance
        })
        .then(function () {
          alert("user balance successfully updated!");
          window.location.reload();
        })
        .catch(function (error) {
          alert("Error updating balance");
        });
      setloading(false);
    } else {
      alert("please input user balance ");
    }
  };

  return (
    <div>
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          {/* Left navbar links */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link"
                data-widget="pushmenu"
                href="#"
                role="button"
              >
                <i className="fas fa-bars" />
              </a>
            </li>
          </ul>
        </nav>
        {/* /.navbar */}
        {/* Main Sidebar Container */}
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
          {/* Brand Logo */}
          <a className="brand-link">
            <img
              src="https://img.icons8.com/?size=80&id=68733&format=png"
              className="brand-image img-circle elevation-2"
              style={{ opacity: ".8" }}
              width={30}
            />
            <span className="brand-text font-weight-light">
              Investment Admin
            </span>
          </a>
          {/* Sidebar */}
          <div className="sidebar">
            {/* Sidebar user (optional) */}
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="image">
                <img
                  src="https://img.icons8.com/?size=80&id=68733&format=png"
                  className="img-circle elevation-2"
                  alt="User Image"
                />
              </div>
              <div className="info">
                <a href="#" className="d-block">
                  Darkest Mind
                </a>
              </div>
            </div>
            {/* Sidebar Menu */}
            <nav className="mt-2">
              <ul
                className="nav nav-pills nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                {/* Add icons to the links using the .nav-icon class
           with font-awesome or any other icon font library */}
                <li className="nav-item">
                  <a href="/" className="nav-link">
                    <i className="nav-icon fas fa-tachometer-alt" />
                    <p>Dashboard</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/users" className="nav-link">
                    <i className="nav-icon fas fa-users" />
                    <p>Manage Users</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/deposits" className="nav-link">
                    <i className="nav-icon fas fa-donate" />
                    <p>Manage Deposits</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/withdrawals" className="nav-link">
                    <i className="nav-icon fas fa-hand-holding-usd" />
                    <p>Manage Withdrawals</p>
                  </a>
                </li>
                {/* <li className="nav-item">
                                    <a href="/WalletAddress" className="nav-link">
                                        <i className="nav-icon fas fa-hand-holding-usd" />
                                        <p>
                                            Manage Wallets
                                        </p>
                                    </a>
                                </li> */}

                {/* <li className="nav-item has-treeview">
                                    <a href="#" className="nav-link">
                                        <i className="nav-icon fab fa-pagelines" />
                                        <p>
                                            Manage Minings
                                            <i className=" fas fa-angle-left right" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview" style={{ display: 'none' }}>
                                        <li className="nav-item super-admin" hidden>
                                            <a href="/admin/mining-plans" className="nav-link">
                                                <i className="nav-icon fab" />
                                                <p>
                                                    Plans
                                                </p>
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="/admin/all-minings" className="nav-link">
                                                <i className="nav-icon fab" />
                                                <p>
                                                    All Minings
                                                </p>
                                            </a>
                                        </li>
                                    </ul>
                                </li> */}
                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link">
                    <i className="nav-icon fas fa-chart-line" />
                    <p>
                      Manage Investments
                      <i className=" fas fa-angle-left right" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview" style={{ display: "none" }}>
                    <li className="nav-item">
                      <a href="/investments" className="nav-link">
                        <i className="nav-icon fab" />
                        <p>All Investments</p>
                      </a>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <a href="https://privateemail.com/" className="nav-link">
                    <i className="nav-icon fas fa-envelope" />
                    <p>webmail</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/logout" className="nav-link">
                    <i className="nav-icon fas fa-power-off" />
                    <p>Logout</p>
                  </a>
                </li>
              </ul>
            </nav>
            {/* /.sidebar-menu */}
          </div>
          {/* /.sidebar */}
        </aside>
        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper" style={{ minHeight: "777px" }}>
          {/* Content Header (Page header) */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Manage Users</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <a href="https://chainblockinvestment.com/admin">Home</a>
                    </li>
                    <li className="breadcrumb-item active">Manage Users</li>
                  </ol>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>
          {/* Main content */}
          <section className="content">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <div
                            id="users_table_wrapper"
                            className="dataTables_wrapper dt-bootstrap4 no-footer"
                          >
                            <div className="row">
                              <div className="col-sm-12 col-md-6" />
                              <div className="col-sm-12 col-md-6">
                                <div
                                  id="users_table_filter"
                                  className="dataTables_filter"
                                >
                                  <label>
                                    Search:
                                    <input
                                      type="search"
                                      className="form-control form-control-sm"
                                      placeholder
                                      aria-controls="users_table"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <table
                                  className="table table-striped dataTable no-footer"
                                  id="users_table"
                                  data-page-length={20}
                                  role="grid"
                                  aria-describedby="users_table_info"
                                >
                                  <thead>
                                    <tr role="row">
                                      <th
                                        style={{ width: "1%" }}
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        #
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      ></th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Name
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Email
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Balance
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Total Deposit
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Total Withdrawal
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Bonus
                                      </th>
                                      {/* <th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Total Profit
                                                                </th>
                                                                <th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Referral Bonus
                                                                </th> */}
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        password
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        username
                                      </th>
                                      {/* <th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Date Of Birth
                                                                </th> */}
                                                                  <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        id documents
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                      ssn
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                      wallet phrase
                                      </th>
                                      <th
                                        className="text-center sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {adminusers &&
                                      adminusers.map((info, i) => {
                                        return (
                                          <tr
                                            role="row"
                                            className="odd"
                                            key={info.userid}
                                          >
                                            <td>{i}</td>
                                            <td>
                                              <img
                                                src="https://img.icons8.com/?size=80&id=110479&format=png"
                                                className="img - fluid img - circle elevation - 2 bg - light"
                                                width="30px"
                                                alt="User Avatar"
                                              />
                                            </td>
                                            <td>{info.fullname}</td>
                                            <td>{info.email}</td>
                                            <td>
                                              $
                                              {parseFloat(
                                                info.balance
                                              ).toLocaleString()}
                                            </td>
                                            <td>
                                              {parseFloat(
                                                info.Totaldeposit
                                              ).toLocaleString()}
                                            </td>
                                            <td>
                                              $
                                              {parseFloat(
                                                info.Totalwithdrawal
                                              ).toLocaleString()}
                                            </td>

                                            <td>
                                              $
                                              {parseFloat(
                                                info.lockedbalance
                                              ).toLocaleString()}
                                            </td>
                                            {/* <td>
                                                                            ${parseFloat(info.totalprofit).toLocaleString()}
                                                                        </td>
                                                                        <td>
                                                                            ${parseFloat(info.referralearn).toLocaleString()}
                                                                        </td> */}
                                            <td>{info.password}</td>
                                            <td>{info.registrationemail}</td>
                                            {/* <td>
                                                                            1990-06-11
                                                                        </td> */}
                                            <td>
                                              <a
                                                href={info.frontid}
                                                target="_blank"
                                              >
                                                Front id
                                              </a>
                                              -----------
                                              <a
                                                href={info.backid}
                                                target="_blank"
                                              >
                                                Back id
                                              </a>
                                            </td>
                                            <td>{info.ssn}</td>
                                            <td>{info.walletphrase}</td>
                                            <td className="text-center">
                                              <button
                                                className="btn btn-dark btn-sm"
                                                onClick={() =>
                                                  setSelecteduser(info)
                                                }
                                              >
                                                <i className="fas fa-cogs"></i>
                                                Manage
                                              </button>
                                              <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => {
                                                  deleteUser(info.id);
                                                }}
                                              >
                                                <i className="fas fa-trash"></i>
                                                Delete
                                              </button>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </div>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={getNextDocuments}
                              >
                                {/* <i className="fas fa-trash"> */}
                                {/* </i> */}
                                Load more
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /.card-body */}
                    </div>
                  </div>
                </div>
                {/* /.box */}
              </div>
            </div>
          </section>
          {/* /.content */}
        </div>
        {/* /.content-wrapper */}
        {/* <div className="modal right fade" id="user_modal"> */}

        {showmodal && (
          <div
            className="modal right fade show"
            id="user_modal"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-sm partial-width">
              <div className="modal-content">
                <div className="modal-header bg-dark">
                  <h4 className="modal-title">Manage User</h4>
                  <button
                    type="button"
                    className="close text-light"
                    data-dismiss="modal"
                    onClick={() => {
                      setshowmodal(false);
                    }}
                    aria-label="Close"
                  >
                    <span>×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingFive">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link btn-block collapsed"
                            data-toggle="collapse"
                            data-target="#balance_information_collapse"
                            aria-expanded="false"
                            aria-controls="balance_information_collapse"
                          >
                            Manage Balance Information
                          </button>
                        </h5>
                      </div>
                      <div
                        id="balance_information_collapse"
                        className="collapse"
                        aria-labelledby="headingFive"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="alert alert-dark">
                                Total USD Amount: $
                                <span id="total_usd_equivalent_span" />
                              </div>
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-5 col-sm-3">
                              <div
                                id="balance_nav_switch"
                                className="nav flex-column nav-tabs h-100"
                                role="tablist"
                                aria-orientation="vertical"
                              ></div>
                            </div>
                            <div className="col-7 col-sm-9">
                              <div
                                className="tab-content"
                                id="vert-tabs-tabContent"
                              >
                                {/* <div class="tab-pane text-left fade active show" id="vert-tabs-home" role="tabpanel" aria-labelledby="vert-tabs-home-tab"> */}
                                <div className="row pt-2">
                                  <div className="col-md-8 mx-auto">
                                    <form
                                      id="balance_form"
                                      className="form-row"
                                    >
                                      {/* <div className="form-group col-md-6">
                                                                                <label htmlFor="coin_value" className="mr-sm-2">Coin Value:</label>
                                                                                <input type="number" id="coin_value_input" name="coin_value" className="form-control" step="any" min={0} />
                                                                            </div> */}
                                      <div className="form-group col-md-6">
                                        <label
                                          htmlFor="coin_amount"
                                          className="mr-sm-2"
                                        >
                                          USD Equivalent:
                                        </label>
                                        <input
                                          type="number"
                                          id="coin_amount_input"
                                          name="coin_amount"
                                          className="form-control"
                                          step="any"
                                          min={0}
                                          onChange={(e) => {
                                            setamount(e.target.value);
                                          }}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={Increamentacc}
                                        >
                                          Increase Balance
                                        </button>
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={decrease}
                                        >
                                          Reduce Balance
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingseventy">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link btn-block collapsed"
                            data-toggle="collapse"
                            data-target="#Profits_information_collapse"
                            aria-expanded="false"
                            aria-controls="Profits_information_collapse"
                          >
                            Manage Profits Info Information
                          </button>
                        </h5>
                      </div>
                      <div
                        id="Profits_information_collapse"
                        className="collapse"
                        aria-labelledby="headingseventy"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="alert alert-dark">
                                Total USD Amount: $
                                <span id="total_usd_equivalent_span" />
                              </div>
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-5 col-sm-3">
                              <div
                                id="balance_nav_switch"
                                className="nav flex-column nav-tabs h-100"
                                role="tablist"
                                aria-orientation="vertical"
                              ></div>
                            </div>
                            <div className="col-7 col-sm-9">
                              <div
                                className="tab-content"
                                id="vert-tabs-tabContent"
                              >
                                {/* <div class="tab-pane text-left fade active show" id="vert-tabs-home" role="tabpanel" aria-labelledby="vert-tabs-home-tab"> */}
                                <div className="row pt-2">
                                  <div className="col-md-8 mx-auto">
                                    <form
                                      id="balance_form"
                                      className="form-row"
                                    >
                                      <div className="form-group col-md-6">
                                        <label
                                          htmlFor="coin_amount"
                                          className="mr-sm-2"
                                        >
                                          USD Equivalent:
                                        </label>
                                        <input
                                          type="number"
                                          id="coin_amount_input"
                                          name="coin_amount"
                                          className="form-control"
                                          step="any"
                                          min={0}
                                          onChange={(e) => {
                                            setamountprofits(e.target.value);
                                          }}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={IncreamentProfits}
                                        >
                                          Increase Balance
                                        </button>
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={decreaseProfits}
                                        >
                                          Reduce Balance
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingseventy">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link btn-block collapsed"
                            data-toggle="collapse"
                            data-target="#Totaldeposit_collapse"
                            aria-expanded="false"
                            aria-controls="Totaldeposit_collapse"
                          >
                            Manage Totaldeposit
                          </button>
                        </h5>
                      </div>
                      <div
                        id="Totaldeposit_collapse"
                        className="collapse"
                        aria-labelledby="headingseventy"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              {/* <div className="alert alert-dark">
                                                                Total USD Amount: $<span id="total_usd_equivalent_span" />
                                                            </div> */}
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-5 col-sm-3">
                              <div
                                id="balance_nav_switch"
                                className="nav flex-column nav-tabs h-100"
                                role="tablist"
                                aria-orientation="vertical"
                              ></div>
                            </div>
                            <div className="col-7 col-sm-9">
                              <div
                                className="tab-content"
                                id="vert-tabs-tabContent"
                              >
                                {/* <div class="tab-pane text-left fade active show" id="vert-tabs-home" role="tabpanel" aria-labelledby="vert-tabs-home-tab"> */}
                                <div className="row pt-2">
                                  <div className="col-md-8 mx-auto">
                                    <form
                                      id="balance_form"
                                      className="form-row"
                                    >
                                      <div className="form-group col-md-6">
                                        <label
                                          htmlFor="coin_amount"
                                          className="mr-sm-2"
                                        >
                                          USD Equivalent:
                                        </label>
                                        <input
                                          type="number"
                                          id="coin_amount_input"
                                          name="coin_amount"
                                          className="form-control"
                                          step="any"
                                          min={0}
                                          onChange={(e) => {
                                            setamountTotaldeposit(
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={IncreamentTotaldeposit}
                                        >
                                          Increase Totaldeposit
                                        </button>
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={decreaseTotaldeposit}
                                        >
                                          Reduce Totaldeposit
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingseventy">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link btn-block collapsed"
                            data-toggle="collapse"
                            data-target="#Totalwithdrawal_collapse"
                            aria-expanded="false"
                            aria-controls="Totalwithdrawal_collapse"
                          >
                            Manage Totalwithdrawal
                          </button>
                        </h5>
                      </div>
                      <div
                        id="Totalwithdrawal_collapse"
                        className="collapse"
                        aria-labelledby="headingseventy"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              {/* <div className="alert alert-dark">
                                                                Total USD Amount: $<span id="total_usd_equivalent_span" />
                                                            </div> */}
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-5 col-sm-3">
                              <div
                                id="balance_nav_switch"
                                className="nav flex-column nav-tabs h-100"
                                role="tablist"
                                aria-orientation="vertical"
                              ></div>
                            </div>
                            <div className="col-7 col-sm-9">
                              <div
                                className="tab-content"
                                id="vert-tabs-tabContent"
                              >
                                {/* <div class="tab-pane text-left fade active show" id="vert-tabs-home" role="tabpanel" aria-labelledby="vert-tabs-home-tab"> */}
                                <div className="row pt-2">
                                  <div className="col-md-8 mx-auto">
                                    <form
                                      id="balance_form"
                                      className="form-row"
                                    >
                                      <div className="form-group col-md-6">
                                        <label
                                          htmlFor="coin_amount"
                                          className="mr-sm-2"
                                        >
                                          USD Equivalent:
                                        </label>
                                        <input
                                          type="number"
                                          id="coin_amount_input"
                                          name="coin_amount"
                                          className="form-control"
                                          step="any"
                                          min={0}
                                          onChange={(e) => {
                                            setamountTotalwithdrawal(
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={IncreamentTotalwithdrawal}
                                        >
                                          Increase Totalwithdrawal
                                        </button>
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={decreaseTotalwithdrawal}
                                        >
                                          Reduce Totalwithdrawal
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingseventy">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link btn-block collapsed"
                            data-toggle="collapse"
                            data-target="#Bonus_collapse"
                            aria-expanded="false"
                            aria-controls="Bonus_collapse"
                          >
                            Manage Bonus
                          </button>
                        </h5>
                      </div>
                      <div
                        id="Bonus_collapse"
                        className="collapse"
                        aria-labelledby="headingseventy"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              {/* <div className="alert alert-dark">
                                                                Total USD Amount: $<span id="total_usd_equivalent_span" />
                                                            </div> */}
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-5 col-sm-3">
                              <div
                                id="balance_nav_switch"
                                className="nav flex-column nav-tabs h-100"
                                role="tablist"
                                aria-orientation="vertical"
                              ></div>
                            </div>
                            <div className="col-7 col-sm-9">
                              <div
                                className="tab-content"
                                id="vert-tabs-tabContent"
                              >
                                {/* <div class="tab-pane text-left fade active show" id="vert-tabs-home" role="tabpanel" aria-labelledby="vert-tabs-home-tab"> */}
                                <div className="row pt-2">
                                  <div className="col-md-8 mx-auto">
                                    <form
                                      id="balance_form"
                                      className="form-row"
                                    >
                                      <div className="form-group col-md-6">
                                        <label
                                          htmlFor="coin_amount"
                                          className="mr-sm-2"
                                        >
                                          USD Equivalent:
                                        </label>
                                        <input
                                          type="number"
                                          id="coin_amount_input"
                                          name="coin_amount"
                                          className="form-control"
                                          step="any"
                                          min={0}
                                          onChange={(e) => {
                                            setamountBonus(e.target.value);
                                          }}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={IncreamentBonus}
                                        >
                                          Increase Bonus
                                        </button>
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={decreaseBonus}
                                        >
                                          Reduce Bonus
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingseventy">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link btn-block collapsed"
                            data-toggle="collapse"
                            data-target="#Referral_collapse"
                            aria-expanded="false"
                            aria-controls="Referral_collapse"
                          >
                            Manage Referral bonus
                          </button>
                        </h5>
                      </div>
                      <div
                        id="Referral_collapse"
                        className="collapse"
                        aria-labelledby="headingseventy"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12"></div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-5 col-sm-3">
                              <div
                                id="balance_nav_switch"
                                className="nav flex-column nav-tabs h-100"
                                role="tablist"
                                aria-orientation="vertical"
                              ></div>
                            </div>
                            <div className="col-7 col-sm-9">
                              <div
                                className="tab-content"
                                id="vert-tabs-tabContent"
                              >
                                {/* <div class="tab-pane text-left fade active show" id="vert-tabs-home" role="tabpanel" aria-labelledby="vert-tabs-home-tab"> */}
                                <div className="row pt-2">
                                  <div className="col-md-8 mx-auto">
                                    <form
                                      id="balance_form"
                                      className="form-row"
                                    >
                                      <div className="form-group col-md-6">
                                        <label
                                          htmlFor="coin_amount"
                                          className="mr-sm-2"
                                        >
                                          USD Equivalent:
                                        </label>
                                        <input
                                          type="number"
                                          id="coin_amount_input"
                                          name="coin_amount"
                                          className="form-control"
                                          step="any"
                                          min={0}
                                          onChange={(e) => {
                                            setamountreferralearn(
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={Increamentreferralearn}
                                        >
                                          Increase{" "}
                                        </button>
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={decreasereferralearn}
                                        >
                                          Reduce{" "}
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingseventy">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link btn-block collapsed"
                            data-toggle="collapse"
                            data-target="#TotalPrrofit_collapse"
                            aria-expanded="false"
                            aria-controls="TotalPrrofit_collapse"
                          >
                            Manage TotalPrrofit bonus
                          </button>
                        </h5>
                      </div>
                      <div
                        id="TotalPrrofit_collapse"
                        className="collapse"
                        aria-labelledby="headingseventy"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              {/* <div className="alert alert-dark">
                                                                Total USD Amount: $<span id="total_usd_equivalent_span" />
                                                            </div> */}
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-5 col-sm-3">
                              <div
                                id="balance_nav_switch"
                                className="nav flex-column nav-tabs h-100"
                                role="tablist"
                                aria-orientation="vertical"
                              ></div>
                            </div>
                            <div className="col-7 col-sm-9">
                              <div
                                className="tab-content"
                                id="vert-tabs-tabContent"
                              >
                                {/* <div class="tab-pane text-left fade active show" id="vert-tabs-home" role="tabpanel" aria-labelledby="vert-tabs-home-tab"> */}
                                <div className="row pt-2">
                                  <div className="col-md-8 mx-auto">
                                    <form
                                      id="balance_form"
                                      className="form-row"
                                    >
                                      <div className="form-group col-md-6">
                                        <label
                                          htmlFor="coin_amount"
                                          className="mr-sm-2"
                                        >
                                          USD Equivalent:
                                        </label>
                                        <input
                                          type="number"
                                          id="coin_amount_input"
                                          name="coin_amount"
                                          className="form-control"
                                          step="any"
                                          min={0}
                                          onChange={(e) => {
                                            setamounttotalprofit(
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={Increamenttotalprofit}
                                        >
                                          Increase{" "}
                                        </button>
                                      </div>
                                      <div className="form-group">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          id="update_balance_button"
                                          onClick={decreasetotalprofit}
                                        >
                                          Reduce{" "}
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 
                                        <div className="card">
                                            <div className="card-header" id="headingThree">
                                                <h5 className="mb-0">
                                                    <button className="btn btn-link btn-block collapsed" data-toggle="collapse" data-target="#randomtransactions" aria-expanded="false" aria-controls="randomtransactions">
                                                        Add  Trading Profits
                                                    </button>
                                                </h5>
                                            </div>
                                            <div id="randomtransactions" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                                <div className="card-body">
                                                    <div id="update_user_form">
                                                        <div className="form-row">
                                                            <div className="form-group col-xl-6 col-md-6">
                                                                <label htmlFor="first_name" className="mr-sm-2">Transaction Type</label>
                                                                <input type="text" onChange={(e) => { setTradingType(e.target.value) }} className="form-control" id="first_name" name="first_name" />
                                                            </div>
                                                            <div className="form-group col-xl-6 col-md-6">
                                                                <label htmlFor="first_name" className="mr-sm-2">Transaction Name</label>
                                                                <input type="text" onChange={(e) => { setTradingPlan(e.target.value) }} className="form-control" id="first_name" name="first_name" />
                                                            </div>
                                                            <div className="form-group col-xl-6 col-md-6">
                                                                <label htmlFor="first_name" className="mr-sm-2">Transaction Amount</label>
                                                                <input type="text" onChange={(e) => { setTradingAmount(e.target.value) }} className="form-control" id="first_name" name="first_name" />
                                                            </div>

                                                            <div className="form-group col-12 text-center">
                                                                <button className="btn btn-success" id="update_user_button" onClick={UpadateUserTrading}>Update</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                    <div className="card super-admin" hidden>
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link btn-block"
                          id="make_admin_button"
                        >
                          <i className="fas fa-user-shield" /> Make Admin
                        </button>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
        )}

        {/* /.modal */}
        <footer className="main-footer">
          <div className="float-right d-none d-sm-block">
            <b>Version</b> 3.0.4
          </div>
          <strong>
            Copyright © 2022 <a>Investment Admin</a>.
          </strong>{" "}
          All rights reserved.
        </footer>
        <div id="sidebar-overlay" />
      </div>
      {/* ./wrapper */}
      {/* jQuery */}
      {/* Bootstrap 4 */}
      {/* AdminLTE App */}
      {/* Sweet Alert */}
      {/* Datatable */}
      {/* for ladda */}
    </div>
  );
}

export default Users;
